import { useState, useEffect } from 'react';

import LogoUploader from '../../logos/logo-uploader/logo-uploader.component';
import OGMetadataConfiguraiton from './og-metadata/og-metadata-configuration-display.component';
import OGImageConfigurationDisplay from './og-metadata/og-image/og-image-configuration-display.component';
import Spinner from '../../../reusable/spinner/spinner.component';

import {
  Container,
  FieldSection,
  SectionTitle
} from '../configuration-sections.styles';

import Client from '../../../../tools/client';
const client = new Client();

const GeneralConfigurationDisplay = () => {
  const [loading, setLoading] = useState(true);
  const [config, setConfig] = useState({});

  useEffect(() => {
    const fetchConfig = async () => {
      const res = await client.setup();
      setConfig(res.configuration?.site || {});
      setLoading(false);
    };
    fetchConfig();
  }, []);

  if (loading) return <Spinner />;

  return (
    <Container>
      <FieldSection>
        <SectionTitle>Logos</SectionTitle>
         <LogoUploader label="Square Logo" configKey="branding.logo.square" />
        <LogoUploader label="Rectangle Logo" configKey="branding.logo.rectangle" />
      </FieldSection>

      <FieldSection>
        <SectionTitle>Meta Tags</SectionTitle>
        <OGMetadataConfiguraiton />
      </FieldSection>

      <FieldSection>
        <SectionTitle>Open Graph Image</SectionTitle>
        <OGImageConfigurationDisplay />
      </FieldSection>
    </Container>
  );
};

export default GeneralConfigurationDisplay;